import MostFrequentQuestionTypes from 'store/actionTypes/mostFrequentQuestion'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  content: {},
  languages: {}
}

const mostFrequentQuestion = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTIONS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload?.mostFrequentQuestion
      }
    case MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_CONTENT_SUCCESS:
      return {
        ...state,
        content: payload?.content || {}
      }
    case MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_CONTENT_FAILED:
      return {
        ...state,
        content: {}
      }
    case MostFrequentQuestionTypes.UPDATE_FILTER_MOST_FREQUENT_QUESTION_SUCCESS:
      return { ...state, filter: payload }
    case MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_SELECTED_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: {
          ...state.languages,
          [payload?.id]: payload?.languageId
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default mostFrequentQuestion
